var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_368_3847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 68,
    height: 68,
    rx: 34,
    fill: "#F2613F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5455,
    y: 11.5455,
    width: 64.9091,
    height: 64.9091,
    rx: 32.4545,
    stroke: "white",
    strokeWidth: 3.09091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.94 51.1534C46.94 51.5869 46.7677 52.0027 46.4612 52.3093C46.1546 52.6159 45.7388 52.7881 45.3053 52.7881C44.8717 52.7881 44.4559 52.6159 44.1493 52.3093C43.8428 52.0027 43.6705 51.5869 43.6705 51.1534C43.6705 50.7198 43.8428 50.304 44.1493 49.9975C44.4559 49.6909 44.8717 49.5187 45.3053 49.5187C45.7388 49.5187 46.1546 49.6909 46.4612 49.9975C46.7677 50.304 46.94 50.7198 46.94 51.1534ZM45.3053 34.1524C44.9584 34.1524 44.6258 34.2902 44.3805 34.5354C44.1353 34.7807 43.9975 35.1133 43.9975 35.4602V45.9223C43.9975 46.2692 44.1353 46.6018 44.3805 46.8471C44.6258 47.0923 44.9584 47.2301 45.3053 47.2301C45.6521 47.2301 45.9847 47.0923 46.23 46.8471C46.4752 46.6018 46.613 46.2692 46.613 45.9223V35.4602C46.613 35.1133 46.4752 34.7807 46.23 34.5354C45.9847 34.2902 45.6521 34.1524 45.3053 34.1524ZM41.2983 27.3638C43.0402 24.2121 47.5703 24.2121 49.3123 27.3638L63.0347 52.2101C64.7204 55.2598 62.5129 59 59.029 59H31.5828C28.0976 59 25.8914 55.2598 27.5758 52.2101L41.2983 27.3638ZM47.0224 28.6284C46.8528 28.3215 46.6041 28.0656 46.3021 27.8874C46.0001 27.7092 45.6559 27.6152 45.3053 27.6152C44.9546 27.6152 44.6104 27.7092 44.3084 27.8874C44.0064 28.0656 43.7577 28.3215 43.5882 28.6284L29.8657 53.4747C29.7009 53.7733 29.6167 54.1098 29.6216 54.4509C29.6265 54.792 29.7202 55.126 29.8936 55.4198C30.067 55.7136 30.314 55.9571 30.6102 56.1263C30.9065 56.2954 31.2417 56.3844 31.5828 56.3845H59.029C59.3701 56.3844 59.7053 56.2954 60.0016 56.1263C60.2978 55.9571 60.5448 55.7136 60.7182 55.4198C60.8916 55.126 60.9853 54.792 60.9902 54.4509C60.9951 54.1098 60.9109 53.7733 60.7461 53.4747L47.0224 28.6284Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_368_3847",
    x: 0.181818,
    y: -0.818182,
    width: 89.6364,
    height: 89.6364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.40909
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.537255 0 0 0 0 0.568627 0 0 0 0 0.611765 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_368_3847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_368_3847",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.71c32a871e347d781f1d06cabcef55c7.svg";
export { ForwardRef as ReactComponent };